"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilterOps = {
    and: 'and',
    eq: 'eq',
    lte: 'lte',
    gte: 'gte',
    has: 'has',
    inArray: 'in',
    matches: 'matches',
    or: 'or'
};
exports.FilterFieldNames = {
    connectionType: 'connectionType',
    createdAt: 'createdAt',
    databaseUsername: 'databaseUsername',
    datasourceId: 'datasourceId',
    domainId: 'domainId',
    domainName: 'domainName',
    groupId: 'groupId',
    groupIds: 'groupIds',
    hasAlert: 'hasAlert',
    hasExtracts: 'hasExtracts',
    hasEmbeddedPassword: 'hasEmbeddedPassword',
    isCertified: 'isCertified',
    isDefaultPort: 'isDefaultPort',
    isFavorite: 'isFavorite',
    isPublished: 'isPublished',
    isRecent: 'isRecent',
    lastRefreshedAt: 'lastRefreshedAt',
    maxSiteRole: 'maxSiteRole',
    minimumSiteRole: 'minimumSiteRole',
    ownerId: 'ownerId',
    parentId: 'parentId',
    parentType: 'parentType',
    projectId: 'projectId',
    scheduledAction: 'scheduledAction',
    scheduleId: 'scheduleId',
    serverName: 'serverName',
    serverPort: 'serverPort',
    siteId: 'siteId',
    siteRole: 'siteRole',
    tags: 'tags',
    updatedAt: 'updatedAt',
    userId: 'userId',
    urlName: 'repositoryUrl',
    workbookId: 'workbookId'
};
//# sourceMappingURL=IFilterClause.js.map